import { render, staticRenderFns } from "./ProductDataTable.vue?vue&type=template&id=0b9b1f72"
import script from "./ProductDataTable.vue?vue&type=script&lang=js"
export * from "./ProductDataTable.vue?vue&type=script&lang=js"
import style0 from "./ProductDataTable.vue?vue&type=style&index=0&id=0b9b1f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports